import { CLPBilling } from "./clpBilling.model";
import { eCLPPricingContract, eCLPRole } from "./enum.model";
import { GenericSmallList, SimpleResponse } from "./genericResponse.model";
import { keyValue } from "./search.model";

export interface CLPTxn {
  cLPTxnID: number;
  cLPCompanyID: number;
  cLPUserID: number;
  cLPInvoiceID: number;
  txnMethod: number;
  txnType: number;
  txnAmount: number;
  txnDescription: string;
  responseText: string;
  rawResponse: string;
  cCTxnID: string;
  cCApprovalCode: string;
  status: number;
  isMonthlyBilling: boolean;
  dtModified: Date;
  dtCreated: Date;
  bizLine: number;
  teamCode: number;
  billingProfileID: number;
}

export interface BillingHistoryYearResponse {
  filterYear: keyValue[];
  billingHistory: CLPTxn[];
}

export interface ChangeContractRequest {
  cLPCompanyID: number;
  contract: number;
  numMonths: number;
  feeUser: number;
  feeCompany: number;
  discountUser: number;
  promoLength: number;
  startDate: string;
}

export interface BillingHistoryResponse {
  billingHistory: CLPTxn[];
}

export interface CLPTxnListResponse extends SimpleResponse {
  listCLPTxn: CLPTxn[];
}

export interface CLPTxnResponse extends SimpleResponse {
  cLPTxn: CLPTxn;
}

export interface BillingInvoice {
  title: string;
  date: Date;
  invoiceNumber: string;
  poNumber: string;
  billTo: string;
  invoiceItems: CLPInvoiceItem[];
  totalAmount: number;
  note: string;
  rptLink: string;
  html: string;
  bizLine: number;
}

export interface CLPInvoiceItem {
  cLPInvoiceItemID: number;
  cLPInvoiceID: number;
  itemDescription: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  dtModified: Date;
  dtCreated: Date;
}

export interface BillingInvoiceResponse {
  billingInvoice: BillingInvoice;
}

export interface CLPBillingProfileDetail {
  billingProfileID: number;
  acctNum: string;
  acctNumDisplay: string;
  isShowDelete: boolean;
}

export interface CCBillingProfileLoadResponse extends SimpleResponse {
  strBPPrimary: string;
  strBPBackup: string;
  strSODigitalBPPrimary: string;
  strSODigitalBPBackup: string;
  strSOProServBPPrimary: string;
  strSOProServBPBackup: string;
  clpBilling: CLPBilling;
  billingProfileDetails: CLPBillingProfileDetail[];
}

export interface CLPBillingProfile {
  billingProfileID: number;
  cLPCompanyID: number;
  cLPUserID: number;
  acctType: number;
  acctName: string;
  bankName: string;
  acctNum: string;
  acctNum2: string;
  cVV: string;
  exMonth: number;
  exYear: number;
  add1: string;
  city: string;
  state: string;
  zip: string;
  encAcctNum: string;
  dtCreated: string;
}

export interface CLPBillingProfileResponse extends SimpleResponse {
  clpBillingProfile: CLPBillingProfile;
}

export interface BillingHistoryLoadResonse extends SimpleResponse {
  ddHYear: GenericSmallList[];
  BillingHistoryList: BillingHistory[];
}

export interface BillingHistory {
  clpTxnID: number;
  dtCreated: string | null;
  txnDescription: string;
  txnAmount: number;
  downLoadURL: string;
}

export interface BillingHistoryListResponse extends SimpleResponse {
  billingHistoryList: BillingHistory[];
}

export interface GeneratePdfData extends SimpleResponse {
  invoiceNumber: string;
  fileResult: any;
}
export interface clpbillingSummaryResponse extends SimpleResponse {
  clpbillingSummary: clpbillingSummary[];
}

export interface clpbillingSummary extends CLPBilling {
  companyName: string;
  companySatus: number;
  numUsers: number;
  balanceDue: number;
  strBalanceDue: string;
  strMonthlyFee: string;
  monthlyFee: number;
  htmlFee: number;
  htmlFeeDisp: string;
  due: string;
  isHTMLEmailIncluded: boolean;
}

export interface BillingAuditReportResponse extends SimpleResponse {
  billingAuditReport: BillingAuditReport[];
}

export interface BillingAuditReport {
  id: number;
  lastTxnDate: string;
  ofTxns: number;
  companyName: string;
  solution: eCLPRole;
  users: number;
  contract: eCLPPricingContract;
  contractExpDate: string;
  nextBillingDate: string;
}
